<span class='tag'
    [class.selected]="isSelected"
    (click)='switch()'>
  {{label}}
</span>
